import { CheckOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Notification } from "@contexts/Notifications/types";
import * as S from "./styles";
import { formatDate } from "@utils/formatters";

interface Props {
  notification: Notification;
  onAccept: (id: string) => Promise<void>;
  isAccepting: boolean;
}

export function NotificationItem({
  notification,
  onAccept,
  isAccepting,
}: Readonly<Props>) {
  const [isImageFailed, setIsImageFailed] = useState(false);
  const hasImageUrl = !!notification.imagem_url;

  useEffect(() => {
    setIsImageFailed(false);
  }, [notification.imagem_url]);

  return (
    <S.Wrapper>
      <S.Container $visualizada={notification.visualizada}>
        {hasImageUrl &&
          (isImageFailed ? (
            <S.ImageFallback
              data-testid="notification-image-fallback"
              aria-hidden="true"
            />
          ) : (
            <S.Image
              src={notification.imagem_url ?? ""}
              alt={notification.titulo}
              onError={() => setIsImageFailed(true)}
            />
          ))}

        <S.Content>
          <S.Title>{notification.titulo}</S.Title>
          <S.Description>{notification.descricao}</S.Description>

          {notification.link && (
            <S.ActionLink
              href={notification.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Ver agora
            </S.ActionLink>
          )}

          {notification.exige_aceite &&
            (notification.aceita ? (
              <S.AcceptButton disabled size="small" icon={<CheckOutlined />}>
                Li e estou ciente
              </S.AcceptButton>
            ) : (
              <S.AcceptButton
                size="small"
                onClick={() => void onAccept(notification.id)}
                loading={isAccepting}
              >
                Li e estou ciente
              </S.AcceptButton>
            ))}
        </S.Content>
      </S.Container>

      <S.Date>
        {formatDate(notification.publicada_em, "DD/MM/YYYY hh:mm A")}
      </S.Date>
    </S.Wrapper>
  );
}
